import { useEffect } from 'react';
import ChannelTalkService from '../util/channelTalkService';

const useChannelTalk = () => {
  useEffect(() => {
    const pluginId = process.env.REACT_APP_CHANNEL_TALK_PLUGIN ?? '';

    ChannelTalkService.boot({
      pluginKey: pluginId,
    });
    return () => {
      ChannelTalkService.shutdown();
    };
  }, []);
  return true;
};

export default useChannelTalk;
